module.exports = __webpack_public_path__ + "img/federation.ff913ea6.svg";